<!-- register form -->

<div class="head-form relative full-width txt-center light-2">
  <h3>
    {{ 'formTitle.a' | translate }}
    <strong> {{ 'formTitle.b' | translate }} </strong>
  </h3>
</div>

<div class="register-form relative-left full-width">
  <form [formGroup]="registerForm" class="relative-left full-width">
    <div class="relative-left padding-left-right-20">
      <div class="relative-left full-width margin-top-bottom-5 two-boxes">
        <mat-form-field class="box">
          <mat-label>{{'form.fname' | translate}}</mat-label>
          <input formControlName="name" type="text" matInput placeholder="{{'form.fnameExample' | translate }}" />
          <mat-icon matPrefix>account_circle</mat-icon>
          <mat-error *ngIf="registerForm.get('name').hasError('required')"> {{'LOGIN.VALIDATE.NAME.REQUIRED' | translate}} </mat-error>
          <mat-error *ngIf="registerForm.get('name').hasError('minlength') || registerForm.get('name').errors?.pattern">
            {{'LOGIN.VALIDATE.NAME.ENTER' | translate}}
          </mat-error>
          <mat-error *ngIf="registerForm.get('name').errors?.maxlength"> {{'LOGIN.VALIDATE.NAME.MAXIMUN' | translate}} </mat-error>
        </mat-form-field>
        <mat-form-field class="box">
          <mat-label>{{'form.lname' | translate}}</mat-label>
          <input formControlName="last_name" type="text" matInput placeholder="{{'form.lnameExample' | translate }}" />
          <mat-icon matPrefix>account_circle</mat-icon>
          <mat-error *ngIf="registerForm.get('last_name').errors?.required"> {{'LOGIN.VALIDATE.NAME.REQUIRED' | translate}} </mat-error>
          <mat-error *ngIf="registerForm.get('last_name').errors?.minlength || registerForm.get('last_name').errors?.pattern">
            {{'LOGIN.VALIDATE.NAME.ENTER' | translate}}
          </mat-error>
          <mat-error *ngIf="registerForm.get('last_name').errors?.maxlength"> {{'LOGIN.VALIDATE.NAME.MAXIMUN' | translate}} </mat-error>
        </mat-form-field>
      </div>

      <div class="relative-left full-width two-boxes margin-top-bottom-5">
        <mat-form-field class="box">
          <mat-label>{{'form.email' | translate}}</mat-label>
          <input
            oninput="this.value = this.value.toLowerCase()"
            formControlName="email"
            type="email"
            matInput
            placeholder="{{'form.emailExample' | translate }}"
            (ngModelChange)="this.errorMailExist = false"
          />
          <mat-icon matPrefix>email</mat-icon>
          <mat-error *ngIf="registerForm.get('email').errors?.pattern || registerForm.get('email').errors?.email">
            {{'LOGIN.VALIDATE.MAIL.ENTER' | translate}}
          </mat-error>
          <mat-error *ngIf="registerForm.get('email').errors?.required"> {{'LOGIN.VALIDATE.MAIL.REQUIRED' | translate}} </mat-error>
        </mat-form-field>

        <mat-form-field class="box">
          <mat-label>{{'form.pass' | translate}}</mat-label>
          <input formControlName="password" matInput placeholder="{{'form.passExample' | translate }}" [type]="isHide ? 'password' : 'text'" />
          <mat-icon matPrefix>lock</mat-icon>
          <mat-icon class="pointer" matSuffix (click)="showPassword()"> {{isHide ? 'visibility_off' : 'visibility'}}</mat-icon>
          <mat-error *ngIf="registerForm.get('password').errors?.required"> {{'LOGIN.VALIDATE.PASSWORD.ENTER' | translate}} </mat-error>
          <mat-error *ngIf="registerForm.get('password').errors?.minlength"> {{'LOGIN.VALIDATE.PASSWORD.MINIMUN' | translate}} </mat-error>
          <mat-error *ngIf="registerForm.get('password').errors?.pattern"> {{'LOGIN.VALIDATE.PASSWORD.SPECIALCHAR' | translate}} </mat-error>
          <mat-error *ngIf="registerForm.get('password').errors?.maxlength"> {{'LOGIN.VALIDATE.PASSWORD.MAXIMUN' | translate}} </mat-error>
        </mat-form-field>
      </div>

      <!-- Begin Country -->
      <div class="relative-left full-width margin-top-bottom-5 two-boxes">
        <mat-form-field class="box">
          <mat-label>{{'LOGIN.PLACEHOLDER.COUNTRY' | translate}}</mat-label>
          <input
            type="text"
            placeholder="Ex. Canadá"
            aria-label="Your Country"
            matInput
            formControlName="country"
            [matAutocomplete]="auto"
            placeholder="{{'form.countryExample' | translate }}"
            (ngModelChange)="setDialCode();countryControls();getCountry()"
          />
          <mat-icon matPrefix>landscape</mat-icon>
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of filteredCountries | async" [value]="option.name" (onSelectionChange)="getCountry(option)">
              {{option.name}}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="registerForm.get('country').hasError"> {{'LOGIN.VALIDATE.COUNTRY.ENTER' | translate}} </mat-error>
        </mat-form-field>
        <!-- End Country -->

        <mat-form-field class="box">
          <mat-label>{{'form.phone' | translate}}</mat-label>
          <span matPrefix *ngIf="!dialcode.isValid"> +&nbsp; </span>
          <span matPrefix *ngIf="dialcode.isValid">
            <img class="inline-block margin-right-5" [attr.src]="'https://flagcdn.com/'+ dialcode.alpha2Code.toLowerCase() + '.svg'" width="20" />
            <small class="relative normal-10 dialcode-print-number inline-block"> +{{dialcode.callingCodes[0]}}&nbsp; </small>
          </span>
          <input
            formControlName="phone"
            type="text"
            matInput
            placeholder="{{'form.phoneExample' | translate}}"
            (ngModelChange)="this.errorNumberPhone = false"
          />
          <mat-icon matPrefix>smartphone</mat-icon>
          <mat-error *ngIf="registerForm.get('phone').hasError('pattern')"> {{'LOGIN.VALIDATE.PHONE.ONLY' | translate}} </mat-error>
        </mat-form-field>
        <div class="full-width two-boxes margin-bottom-10 relative-right bottom-15">
          <p *ngIf="onValidator('phone', 'maxlength') || errorNumberPhone" class="form-note relative-left box">
            <small>
              <span class="login-error-msg"> {{'LOGIN.VALIDATE.PHONE.ENTER' | translate}} </span>
            </small>
          </p>
        </div>
      </div>

      <!-- Begin State -->
      <mat-form-field *ngIf="showState" class="full-width margin-top-bottom-5">
        <mat-label>{{'LOGIN.PLACEHOLDER.STATE' | translate}}</mat-label>
        <input
          type="text"
          aria-label="Your State"
          matInput
          formControlName="state"
          [matAutocomplete]="auto"
          placeholder="{{'form.stateExample' | translate }}"
        />
        <mat-icon matPrefix>landscape</mat-icon>
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let states of filteredStates | async" [value]="states.name"> {{states.name}} </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="registerForm.get('state').hasError"> {{'LOGIN.VALIDATE.STATE.ENTER' | translate}} </mat-error>
      </mat-form-field>
      <!-- End State -->

      <div class="relative-left full-width margin-top-bottom-5 two-boxes">
        <!-- Begin CPF -->
        <mat-form-field class="full-width margin-top-bottom-10" *ngIf="country?.iso ==='BR'">
          <mat-label>{{'CPF.TITLE' | translate}}</mat-label>
          <input oninput="this.value = this.value.toLowerCase()" formControlName="ssn" type="text" matInput placeholder="" />
          <mat-icon matPrefix>person_pin</mat-icon>
          <mat-error *ngIf="errorCpfInvalid"> {{'LOGIN.VALIDATE.CPF.ENTER' | translate}} </mat-error>
          <mat-error *ngIf="errorCpfInvalid" style="float: right; text-align: left; font-size: 12px"> {{'CPF.CONTENT' | translate}} </mat-error>
        </mat-form-field>
        <!-- End CPF -->

        <!-- SSN Country -->
        <mat-form-field *ngIf="country?.iso !=='BR'" [ngClass]="setClass">
          <mat-label>{{'form.ssn' | translate}}</mat-label>
          <input type="text" placeholder="" aria-label="Your SSN" matInput formControlName="ssn" />
          <mat-icon matPrefix>perm_identity</mat-icon>
          <mat-error *ngIf="errorCpfInvalid"> {{'LOGIN.VALIDATE.CPF.ENTER' | translate}} </mat-error>
        </mat-form-field>
        <!-- End SSN -->

        <!-- Begin SSN Type -->
        <mat-form-field class="box" *ngIf="country?.iso ==='CO'">
          <mat-label>{{'LOGIN.PLACEHOLDER.SSN_TYPE' | translate}}</mat-label>
          <input
            type="text"
            placeholder=" "
            aria-label="Your SSN Type"
            matInput
            formControlName="ssn_type"
            [matAutocomplete]="autoSSNType"
            (ngModelChange)="getSSNOption();"
          />
          <mat-icon matPrefix>perm_identity</mat-icon>
          <mat-autocomplete #autoSSNType="matAutocomplete">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option.name" (onSelectionChange)="getSSNOption(option)">
              {{option.name}}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="registerForm.get('ssn_type').hasError"> {{'LOGIN.VALIDATE.SSN_TYPE.ENTER' | translate}} </mat-error>
        </mat-form-field>
        <!-- End ssn type -->
      </div>

      <div class="relative-left full-width margin-top-bottom-5 two-boxes">
        <!-- Begin Birth Country -->
        <mat-form-field class="box">
          <mat-label>{{'LOGIN.PLACEHOLDER.COUNTRY_BIRTH' | translate}}</mat-label>
          <input
            type="text"
            placeholder="Ex. Canadá"
            aria-label="Your Birth Country"
            matInput
            formControlName="country_birth"
            [matAutocomplete]="countryBornAutoComplete"
            placeholder="{{'form.countryExample' | translate }}"
            (ngModelChange)="getBirthCountry();"
          />
          <mat-icon matPrefix>landscape</mat-icon>
          <mat-autocomplete #countryBornAutoComplete="matAutocomplete">
            <mat-option *ngFor="let option of filteredBirthCountries | async" [value]="option.name"> {{option.name}} </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="registerForm.get('country_birth').hasError"> {{'LOGIN.VALIDATE.COUNTRY.ENTER' | translate}} </mat-error>
        </mat-form-field>
        <!-- End Birth Country -->

        <!-- Begin Birthday -->
        <mat-form-field class="box">
          <mat-label>{{'LOGIN.PLACEHOLDER.AGE' | translate}}</mat-label>
          <input formControlName="birthdate" type="date" matInput placeholder="{{'LOGIN.PLACEHOLDER.AGE' | translate }}" />
          <mat-icon matPrefix>date_range</mat-icon>
          <mat-error *ngIf="registerForm.get('birthdate').errors?.required"> {{'LOGIN.VALIDATE.AGE.ENTER' | translate}} </mat-error>
          <mat-error *ngIf="registerForm.get('birthdate').errors?.NotAdult"> {{'LOGIN.VALIDATE.AGE.MINIMUN' | translate}} </mat-error>
          <mat-error *ngIf="registerForm.get('birthdate').errors?.TooOld"> {{'LOGIN.VALIDATE.AGE.MAXIMUN' | translate}} </mat-error>
        </mat-form-field>
        <!-- Begin Birthday -->
      </div>

      <!-- Begin Direction -->
      <mat-form-field class="full-width margin-top-bottom-10">
        <mat-label>{{'form.direccion' | translate}}</mat-label>
        <input
          type="text"
          placeholder="Ex. Canadá"
          aria-label="Your Country"
          matInput
          formControlName="address1"
          placeholder="{{'form.countryExample' | translate }}"
          (ngModelChange)="setDialCode();countryControls();getCountry()"
        />
        <mat-icon matPrefix>domain</mat-icon>
        <mat-error *ngIf="registerForm.get('address1').hasError"> {{'form.error' | translate}} </mat-error>
      </mat-form-field>

      <div class="relative-left full-width margin-top-bottom-5 two-boxes">
        <mat-form-field class="box">
          <mat-label>{{'form.city' | translate}}</mat-label>
          <input type="text" placeholder="Ex. London" aria-label="Your City" matInput formControlName="city" />
          <mat-icon matPrefix>business</mat-icon>
          <mat-error *ngIf="registerForm.get('city').hasError"> {{'form.error' | translate}} </mat-error>
        </mat-form-field>

        <mat-form-field class="box">
          <mat-label>{{'form.zipcode' | translate}}</mat-label>
          <input type="text" placeholder="Ex. 12345" aria-label="Your Zipcode" matInput formControlName="zipcode" />
          <mat-icon matPrefix>bookmarker</mat-icon>
          <mat-error *ngIf="registerForm.get('zipcode').hasError"> {{'form.error' | translate}} </mat-error>
        </mat-form-field>
        <!-- End Direction -->
      </div>
    </div>

    <div *ngIf="isStep"><!-- Not used--></div>
    <div class="relative-left full-width txt-center padding-left-right-20 margin-top-10">
      <button mat-button class="play-now button md full-width" (click)="changeStep($event)">
        {{ 'Claim' | translate }} <span class="ico"> <mat-icon matPrefix>arrow_forward</mat-icon> </span>
      </button>
      <div class="terms-container full-width">
        <mat-checkbox [checked]="acceptTerms ? true : false" (change)="onCheckboxChange($event)" class="terms" style="margin-left: 20px">
        </mat-checkbox>
        <p style="font-size: 12px !important; line-height: 35px; margin-left: 5px; color: #fff" *ngIf="('lang' | translate) === 'es'">
          <span style="text-transform: Capitalize; line-height: 35px">Confirmo </span>que acepto los
          <span class="link" (click)="redirecToTerms()">términos y condiciones</span>
        </p>
        <p style="font-size: 12px !important; line-height: 35px; margin-left: 5px; color: #fff" *ngIf="('lang' | translate) === 'en'">
          <span style="text-transform: Capitalize; line-height: 35px">I confirm </span>I accept them
          <span class="link" (click)="redirecToTerms()">terms and Conditions</span>
        </p>
        <p style="font-size: 12px !important; line-height: 35px; margin-left: 5px; color: #fff" *ngIf="('lang' | translate) === 'pt'">
          <span style="text-transform: Capitalize; line-height: 35px">Confirmar </span>que aceito los
          <span class="link" (click)="redirecToTerms()">términos y condiciones</span>
        </p>
      </div>

      <h4 *ngIf="errorFormInvalid" class="login-error-msg full-width txt-center padding-5">{{'ERROR.GENERIC' | translate}}</h4>
      <h4 *ngIf="errorMailExist" class="login-error-msg full-width txt-center padding-5">{{'LOGIN.VALIDATE.MAIL.EXISTS' | translate}}</h4>
      <h4 *ngIf="errorCpfInvalid" class="login-error-msg full-width txt-center padding-5">{{'CPF.CONTENT' | translate}}</h4>
      <h4 *ngIf="errorNumberPhone" class="login-error-msg full-width txt-center padding-5">{{'LOGIN.VALIDATE.PHONE.ENTER' | translate}}</h4>
      <h4 *ngIf="errorInvalidState" class="login-error-msg full-width txt-center padding-5">{{'LOGIN.VALIDATE.STATE.ENTER' | translate}}</h4>

      <div *ngIf="loading">
        <app-spinner></app-spinner>
      </div>
      <h4 *ngIf="error && !loading" class="login-error-msg full-width txt-center padding-5">{{'ERROR.GENERIC' | translate}}</h4>
    </div>
  </form>
</div>
